import React, { useState, useEffect } from "react";
import {
    ListTask,
    Grid3x3GapFill,
    ThreeDotsVertical,
    BackspaceFill,
    Journals
} from "react-bootstrap-icons";

import "./home.scss";
import { Container } from "react-bootstrap";
import LinkGridItem from "../components/link-grid-item";
import LinkListItem from "../components/link-list-item";
import incidentFormLogo from "../assets/IncidentForm_Color.svg";
import safetyCertificationsLogo from "../assets/SafetyCertifications_Color.svg";
import covidTrackerLogo from "../assets/CovidTracker_Color.svg";
import jobsiteHubLogo from "../assets/JobsiteHub_Color_02.svg";
import safetySearchLogo from "../assets/SafetySearch_Color.svg";
import autodeskLogo from "../assets/AutoDesk_Color.svg";
import bifsoLogo from "../assets/Bifso_Color.svg";
import jobsiteSubcontractorManagement from "../assets/SubcontractorManagement_Color.svg";
import claycoRising from "../assets/ClaycoRising_Color.svg";
import otherResourcesLogo from "../assets/OtherResources_Color.svg";
import safetyCodeLogo from "../assets/SafetyCode_Color.svg";
import safetyCodeSpanishLogo from "../assets/SafetyCodeSpanish_Color.svg";
import safetyVideosLogo from "../assets/SafetyVideoIcon_Color.svg";

const isMobile = window.matchMedia("(max-width: 600px)").matches;

const Home = () => {
    const [incidentFormUrl, setIncidentFormUrl] = useState();
    const [safetyCertificationsUrl, setSafetyCertificationsUrl] = useState();
    const [jobsiteHubUrl, setJobsiteHubUrl] = useState();
    const [safetySearchUrl, setSafetySearchUrl] = useState();
    const [bifsoUrl, setBifsoUrl] = useState();
    const [subsUrl, setSubsUrl] = useState();
    const [claycoRisingUrl, setClaycoRisingUrl] = useState();
    const [safetyCodeUrl, setSafetyCodeUrl] = useState();
    const [safetyCodeSpanishUrl, setSafetyCodeSpanishUrl] = useState();
    const [safetyVideosUrl, setSafetyVideosUrl] = useState();

    const [show, setShow] = useState("grid");

    useEffect(() => {
        const fetchData = async () => {
            await fetch("/settings.json", {
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    window.env = setIncidentFormUrl(data.incidentFormUrl);
                    setSafetyCertificationsUrl(data.safetyCertificationsUrl);
                    setJobsiteHubUrl(data.jobsiteHubUrl);
                    setSafetySearchUrl(data.safetySearchUrl);
                    setBifsoUrl(data.bifsoUrl);
                    setSubsUrl(data.subsUrl);
                    setClaycoRisingUrl(data.claycoRisingUrl);
                    setSafetyCodeUrl(data.safetyCodeUrl);
                    setSafetyCodeSpanishUrl(data.safetyCodeSpanishUrl);
                    setSafetyVideosUrl(data.safetyVideosUrl);
                })
                .catch((error) => console.log(error));
        };
        fetchData();
    }, []);

    const apps = [
        {
            url: incidentFormUrl,
            text: "Incident Form",
            target: "",
            image: incidentFormLogo,
            description: "Report and Manage Incidents and Injuries",
            keywords: "Incident Form Report and Manage Incidents and Injuries",
            hideOnMobile: false,
        },
        {
            url: "https://employeeportal.claycorp.com/Skills/certifications",
            text: "Safety Certifications",
            target: "_blank",
            image: safetyCertificationsLogo,
            description: "Manage your Safety Certifications",
            keywords: "Safety Certifications Manage your Safety Certifications",
            hideOnMobile: false,
        },
        {
            url: jobsiteHubUrl,
            text: "Jobsite Hub",
            target: "_blank",
            image: jobsiteHubLogo,
            description: "Access to Jobsite Media Pages and Portals",
            keywords: "Jobsite Hub Access to Jobsite Media Pages and Portals",
            hideOnMobile: true,
        },
        {
            url: safetySearchUrl,
            text: "Safety Search",
            target: "",
            image: safetySearchLogo,
            description:
                "Find the Latest Safety Documentation, Policies, and Guides",
            keywords:
                "Jobsite Hub Find the Latest Safety Documentation, Policies, and Guides",
            hideOnMobile: false,
        },
        {
            url: bifsoUrl,
            text: "BIFSO",
            target: "",
            image: bifsoLogo,
            description:
                "Complete an observation of how workers approach their task",
            keywords:
                "Boots in the Field Safety Observation, bifso, Complete an observation of how workers approach their task",
            hideOnMobile: false,
        },
        {
            url: subsUrl,
            text: "Jobsite Subcontractor Management",
            target: "",
            image: jobsiteSubcontractorManagement,
            description: "Keep track of subcontractors at a jobsite.",
            keywords:
                "Jobsite Subcontractor Management, Keep track of subcontractors at a jobsite.",
            hideOnMobile: false,
        },
        {
            url: claycoRisingUrl,
            text: "Clayco Rising",
            target: "",
            image: claycoRising,
            description:
                "Creating meaningful opportunity for our employees, our minority and women-owned business partners and people within the communities we serve.",
            keywords:
                "Clayco Rising. Creating meaningful opportunity for our employees, our minority and women-owned business partners and people within the communities we serve.",
            hideOnMobile: false,
        },
        {
            url: safetyCodeUrl,
            text: "Safety & Health Code",
            target: "_blank",
            image: safetyCodeLogo,
            description:
                "Current guidelines, regulations, standards, and procedures aimed at ensuring the health and safety of Clayco employees and contractors.",
            keywords:
                "Current guidelines, regulations, standards, and procedures aimed at ensuring the health and safety of Clayco employees and contractors.",
            hideOnMobile: false,
        },
        {
            url: safetyCodeSpanishUrl,
            text: "Código de seguridad y salud",
            target: "_blank",
            image: safetyCodeSpanishLogo,
            description:
                "Lineamientos, regulaciones, estándares y procedimientos vigentes destinados a garantizar la salud y seguridad de los empleados y contratistas de Clayco.",
            keywords:
                "Lineamientos, regulaciones, estándares y procedimientos vigentes destinados a garantizar la salud y seguridad de los empleados y contratistas de Clayco.",
            hideOnMobile: false,
        },
        {
            url: safetyVideosUrl,
            text: "Safety Videos",
            target: "_blank",
            image: safetyVideosLogo,
            description: "A collection of safety training videos.",
            keywords: "A collection of safety training videos, including Weather, Tools, PPE, and more.",
            hideOnMobile: false,
        }
        // {
        //     url: "https://accounts.autodesk.com/",
        //     text: "Safety Issues and Checklists",
        //     target: "_blank",
        //     image: autodeskLogo,
        //     description: "Submit Safety Issues, Audits, and Observations",
        //     keywords:
        //         "Safety Issues and Checklists Autodesk Submit Safety Issues, Audits, and Observations",
        //     hideOnMobile: false,
        // },
        // {
        //     url: "https://apps.powerapps.com/play/e/default-3e8dbf1c-34b7-46b7-8972-8605842ef0df/a/105da0f8-4a2b-46b2-91b9-8359be4a14c7?tenantId=3e8dbf1c-34b7-46b7-8972-8605842ef0df",
        //     text: "Covid Tracker",
        //     target: "_blank",
        //     image: covidTrackerLogo,
        //     description: "Report and Track COVID Cases",
        //     keywords: "Covid Tracker Report and Track COVID Cases",
        //     hideOnMobile: false,
        // },
    ];

    const otherResources = [
        // {
        //     url: "/other", //Staging: https://test-subs.claycorp.com/
        //     text: "Other Resources",
        //     target: "",
        //     image: otherResourcesLogo,
        //     description: "External links and tools.",
        //     keywords: "Other resources. External links and tools.",
        //     hideOnMobile: false,
        // },
        {
            url: claycoRisingUrl,
            text: "Clayco Rising",
            target: "",
            image: claycoRising,
            description:
                "Creating meaningful opportunity for our employees, our minority and women-owned business partners and people within the communities we serve.",
            keywords:
                "Clayco Rising. Creating meaningful opportunity for our employees, our minority and women-owned business partners and people within the communities we serve.",
            hideOnMobile: false,
        },
    ];

    const [filter, setFilter] = useState("");

    return (
        <Container fluid>
            <div className="row mt-3 mb-4">
                <div className="col-10 col-sm-10 col-md-8 col-lg-6 text-start">
                    <div className="input-group mb-3">
                        <input
                            type="text"
                            className="form-control"
                            id="filter"
                            name="filter"
                            placeholder="Search..."
                            value={filter}
                            onChange={(event) => setFilter(event.target.value)}
                        ></input>
                        <button
                            className="btn btn-outline-secondary"
                            type="button"
                            id="button-addon1"
                            onClick={(event) => setFilter("")}
                        >
                            X
                        </button>
                    </div>
                </div>
                <div className="col-2 col-sm-2 col-md-4 col-lg-6 text-end">
                    {show === "otherresources" && (
                        <button
                            className="view-toggler"
                            onClick={() => setShow("grid")}
                        >
                            <BackspaceFill
                                size="18px"
                                className="d-inline mb-1"
                            ></BackspaceFill>
                            <span> Back To Apps</span>
                        </button>
                    )}
                    {/* {show !== "otherresources" && (
                        <button
                            className="view-toggler"
                            onClick={() => setShow("otherresources")}
                        >
                            <Journals
                                size="18px"
                                className="d-inline mb-2"
                            ></Journals>
                            <span> Other Resources</span>
                        </button>
                    )} */}
                    {show === "grid" && (
                        <button
                            className="view-toggler"
                            onClick={() => setShow("list")}
                        >
                            <ListTask
                                size="20px"
                                className="d-inline mb-1"
                            ></ListTask>
                            <span> List View</span>
                        </button>
                    )}
                    {show === "list" && (
                        <button
                            className="view-toggler"
                            onClick={() => setShow("grid")}
                        >
                            <Grid3x3GapFill
                                size="18px"
                                className="d-inline mb-1"
                            ></Grid3x3GapFill>
                            <span> Grid View</span>
                        </button>
                    )}
                </div>
            </div>
            {show === "grid" && (
                <div id="linkGrid">
                    {
                        <div className="row">
                            {apps
                                .filter((f) =>
                                    isMobile ? f.hideOnMobile === false : <></>
                                )
                                .filter(
                                    (f) =>
                                        f.keywords
                                            .toLowerCase()
                                            .includes(filter.toLowerCase()) ||
                                        filter === ""
                                )
                                .map((link, i) => (
                                    <div
                                        className="col-4 col-md-3 col-lg-3 col-xl-2 mb-4 text-center"
                                        key={i}
                                    >
                                        <LinkGridItem
                                            url={link.url}
                                            text={link.text}
                                            target={link.target}
                                            image={link.image}
                                            description={link.description}
                                        ></LinkGridItem>
                                    </div>
                                ))}
                        </div>
                    }
                </div>
            )}
            {show === "list" && (
                <div id="linkList">
                    {apps
                        .filter((f) =>
                            isMobile ? f.hideOnMobile === false : <></>
                        )
                        .filter(
                            (f) =>
                                f.keywords
                                    .toLowerCase()
                                    .includes(filter.toLowerCase()) ||
                                filter === ""
                        )
                        .map((link, i) => (
                            <LinkListItem
                                key={i}
                                url={link.url}
                                text={link.text}
                                target={link.target}
                                image={link.image}
                                description={link.description}
                            ></LinkListItem>
                        ))}
                </div>
            )}
            {show === "otherresources" && (
                <div id="linkList">
                    {otherResources
                        .filter((f) =>
                            isMobile ? f.hideOnMobile === false : <></>
                        )
                        .filter(
                            (f) =>
                                f.keywords
                                    .toLowerCase()
                                    .includes(filter.toLowerCase()) ||
                                filter === ""
                        )
                        .map((link, i) => (
                            <LinkListItem
                                key={i}
                                url={link.url}
                                text={link.text}
                                target={link.target}
                                image={link.image}
                                description={link.description}
                            ></LinkListItem>
                        ))}
                </div>
            )}
        </Container>
    );
};

export default Home;
